/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

type SearchType = "condition" | "ai";

interface SearchCondition {
  category?: string;
  target?: string;
  purpose?: string;
  budget?: string;
  gender?: string;
  ad_type?: string;
  age_group?: string;
  traffic?: string;
  mediaId?: string;
  mediaGroupIds?: string;
  bounds?: any;
}

type SearchConditionStore = {
  type: SearchType;
  isMyMedia: boolean;
  userCountry: string | null;
  condition: SearchCondition;
  isCompletePrompt: boolean;

  // actions
  setType: (value: SearchType) => void;
  setIsMyMedia: (value: boolean) => void;
  setUserCountry: (value: string | null) => void;
  setCondition: (value: SearchCondition) => void;
  resetCondition: () => void;
  setIsCompletePrompt: (value: boolean) => void;
};

const initialState: Omit<
  SearchConditionStore,
  | "setType"
  | "setIsMyMedia"
  | "setUserCountry"
  | "setCondition"
  | "resetCondition"
  | "setIsCompletePrompt"
> = {
  type: "ai",
  isMyMedia: true,
  userCountry: null,
  condition: {},
  isCompletePrompt: false,
};

export const useSearchConditionStore = create<SearchConditionStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        setType: (type) => set({ type }, false, "setType"),
        setIsMyMedia: (value) =>
          set({ isMyMedia: value }, false, "setIsMyMedia"),
        setUserCountry: (value) =>
          set({ userCountry: value }, false, "setUserCountry"),

        setCondition: (condition) => set({ condition }, false, "setCondition"),
        resetCondition: () => set({ condition: {} }, false, "resetCondition"),
        setIsCompletePrompt: (value) =>
          set({ isCompletePrompt: value }, false, "setIsCompletePrompt"),
      }),
      {
        name: "SearchConditionStoreInfo", // key in localStorage
        partialize: (state) => ({
          type: state.type,
          userCountry: state.userCountry,
          condition: state.condition,
        }),
      }
    ),
    { enabled: process.env.NODE_ENV === "development" }
  )
);
